import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { CartContext } from '../../contexts/CartContext';
import CartItem from '../../components/CartItem';
import './User.css';

export default function Cart() {
  const { cart, updateQuantity, removeFromCart, clearCart, getTotal } = useContext(CartContext);
  const navigate = useNavigate();

  const handleUpdateQuantity = (productId, delta) => {
    updateQuantity(productId, delta);
  };

  const handleRemove = (productId) => {
    if (window.confirm('Remove this item from cart?')) {
      removeFromCart(productId);
    }
  };

  const handleClearCart = () => {
    if (window.confirm('Remove all items from cart?')) {
      clearCart();
    }
  };

  const handleCheckout = () => {
    if (cart.length === 0) {
      alert('Your cart is empty. Please add items first.');
      return;
    }
    navigate('/user/checkout');
  };

  if (cart.length === 0) {
    return (
      <div className="user-cart">
        <div className="container">
          <div className="empty-state">
            <div className="empty-state-icon">🛒</div>
            <h2 className="empty-state-title">Your cart is empty</h2>
            <p className="empty-state-text">Add some fresh items to get started!</p>
            <button
              className="btn btn-primary"
              onClick={() => navigate('/user')}
            >
              Start Shopping
            </button>
          </div>
        </div>
      </div>
    );
  }

  const total = getTotal();

  return (
    <div className="user-cart">
      <div className="container">

        {/* ── Header ── */}
        <div className="cart-header">
          <h1 className="page-title">
            <span className="title-icon">🛒</span>
            Shopping Cart
          </h1>

          {/* ✅ Clear Cart + Continue Shopping dono saath */}
          <div className="cart-header-actions">
            <button
              className="btn btn-outline btn-sm"
              onClick={() => navigate('/user')}
            >
              🛍️ Continue Shopping
            </button>
            <button
              className="btn btn-danger btn-sm"
              onClick={handleClearCart}
            >
              🗑️ Clear Cart
            </button>
          </div>
        </div>

        <div className="cart-content">
          <div className="cart-items">
            {cart.map((item) => (
              <CartItem
                key={item.id}
                item={item}
                onUpdateQuantity={handleUpdateQuantity}
                onRemove={handleRemove}
              />
            ))}
          </div>

          <div className="cart-summary">
            <div className="summary-card">
              <h3 className="summary-title">Order Summary</h3>

              <div className="summary-row">
                <span className="summary-label">Items ({cart.length})</span>
                <span className="summary-value">
                  {cart.reduce((sum, item) => sum + item.quantity, 0)} items
                </span>
              </div>

              <div className="summary-divider"></div>

              <div className="summary-row">
                <span className="summary-label">Subtotal</span>
                <span className="summary-value">Rs. {total}</span>
              </div>

              <div className="summary-row">
                <span className="summary-label">Delivery Fee</span>
                <span className="summary-value">Rs. 120</span>
              </div>

              <div className="summary-divider"></div>

              <div className="summary-row summary-total">
                <span className="summary-label">Total</span>
                <span className="summary-value">Rs. {total + 120}</span>
              </div>

              <button
                className="btn btn-primary btn-block checkout-btn"
                onClick={handleCheckout}
              >
                Proceed to Checkout
              </button>

              <button
                className="btn btn-outline btn-block"
                onClick={() => navigate('/user')}
              >
                Continue Shopping
              </button>
            </div>

            <div className="info-card">
              <h4 className="info-title">💳 Payment Options</h4>
              <ul className="info-list">
                <li>💵 Cash on Delivery</li>
                <li>💳 Card Payment (Coming Soon)</li>
              </ul>
            </div>

            <div className="info-card">
              <h4 className="info-title">🚚 Delivery Info</h4>
              <ul className="info-list">
                <li>Free delivery on orders above Rs. 2000</li>
                <li>Delivery within 24-48 hours</li>
                <li>Track your order in real-time</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}